import React,{useState} from 'react'
import PreCoolingForm from './PreCoolingForm';
import PreCoolingListview from './PreCoolingListview';

const PreCooling = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
    
  
    return (
      <>
        {fromIsShown ? (
          <PreCoolingForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <PreCoolingListview addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}
      </>
  )
}

export default PreCooling